__turbopack_context__.v({
  "checkbox": "_1pc3oq_checkbox",
  "checkbox-label": "_1pc3oq_checkbox-label",
  "placeholder": "_1pc3oq_placeholder",
});
